module.exports = {
	SENTRY_AUTH_TOKEN: '900a56cc6a064b45bc1ae8fa75a963fabfbc6f91ac4b4c87b3fa825736d022d8',
	RELEASE_VERSION: '2023081701',
	ENVIRONMENT: 'production',
	SENTRY_ORG: 'kuaiyin',
	PROJECT_NAME: 'vision-h5',
};



//////////////////
// WEBPACK FOOTER
// ./sentry.config.js
// module id = R27d
// module chunks = 216